import fetch from 'unfetch';
import { csvParse, autoType } from 'd3-dsv';

import { trackEvent } from '~/Utils';

const loadDistributionData = async () => {
  const distributionData = await fetch('public/data/distribution.csv').then(res => res.text());
  return csvParse(distributionData, (d, i) => {
    let income = +(d.Einkommensgruppe.split('-')[0]);

    if (i === 0) {
      income = 0;
    }

    if (d.Einkommensgruppe === '>7000') {
      income = 7000;
    }

    return {
      ...d,
      income
    };
  });
};

const loadCompareData = async () => {
  const compareData = await fetch('public/data/compare.csv').then(res => res.text());
  return csvParse(compareData, autoType);
};

const loadAdditionalData = async () => {
  const additionalData = await fetch('public/data/additional.json').then(res => res.json());
  return additionalData;
};

const loadData = Store => async () => {
  Store.setState({ isLoading: true });

  let distributionData = null;
  let compareData = null;
  let additionalData = null;

  try {
    distributionData = await loadDistributionData();
    compareData = await loadCompareData();
    additionalData = await loadAdditionalData();
  } catch (err) {
    console.log(err);
  }

  return { distributionData, compareData, additionalData, isLoading: false };
};

const setInfoboxContent = (state, infoboxContent) => {
  if (state.infoboxContent === infoboxContent) {
    return { infoboxContent: false };
  }
  return { infoboxContent };
};

const setCompareKey = (state, compareKey) => {
  trackEvent('set_group', compareKey);

  return {
    compareKey
  };
};

const setOverallKey = (state, overallKey) => {
  trackEvent('set_group', overallKey);

  return {
    overallKey
  };
};

const setHouseholdIncome = (state, householdIncome) => ({
  householdIncome: Math.max(0, Math.min(householdIncome, 100000))
});

const setHouseholdMembersAbove14 = (state, householdMembersAbove14) => ({
  householdMembersAbove14
});

const setHouseholdMembersBelow14 = (state, householdMembersBelow14) => ({
  householdMembersBelow14
});

const setTooltipPosition = (state, tooltipX, tooltipY) => ({
  tooltipX, tooltipY
});

const setTooltipVisibility = (state, tooltipVisible) => ({
  tooltipVisible
});

const setTooltipKey = (state, tooltipKey) => ({
  tooltipKey
});

export default Store => ({
  loadData: loadData(Store),
  setInfoboxContent,
  setCompareKey,
  setOverallKey,
  setHouseholdIncome,
  setHouseholdMembersAbove14,
  setHouseholdMembersBelow14,
  setTooltipPosition,
  setTooltipVisibility,
  setTooltipKey
});
